import { HorseMembershipGroupKey, HorseMembershipItem } from '../models/horse/horse.interface'
import { NumberMembershipGroupKey, NumberMembershipItem } from '../models/users/user.interface'
import {
  getDisciplineFields,
  getHorseExpirationFieldName,
  getHorseImageFieldName,
  getHorseNumberFieldName,
  getUserFieldName,
  NumberMembershipFieldKey,
} from './discipline-memberships-const'
// Number memberships for users
export const USER_MEMBERSHIP_GROUPS: Record<NumberMembershipGroupKey, NumberMembershipItem[]> = {
  English: getDisciplineFields('English').map((field) => ({
    fieldKey: getUserFieldName(field.key) as NumberMembershipFieldKey,
    label: field.label,
    icon: field.icon,
  })),
  Western: getDisciplineFields('Western').map((field) => ({
    fieldKey: getUserFieldName(field.key) as NumberMembershipFieldKey,
    label: field.label,
    icon: field.icon,
  })),
  Rodeo: getDisciplineFields('Rodeo').map((field) => ({
    fieldKey: getUserFieldName(field.key) as NumberMembershipFieldKey,
    label: field.label,
    icon: field.icon,
  })),
  College: getDisciplineFields('College').map((field) => ({
    fieldKey: getUserFieldName(field.key) as NumberMembershipFieldKey,
    label: field.label,
    icon: field.icon,
  })),
  Other: getDisciplineFields('Other').map((field) => ({
    fieldKey: getUserFieldName(field.key) as NumberMembershipFieldKey,
    label: field.label,
    icon: field.icon,
  })),
  Pegasus: [],
}

// Number memberships for horses
export const HORSE_MEMBERSHIP_GROUPS: Record<HorseMembershipGroupKey, HorseMembershipItem[]> = {
  English: getDisciplineFields('English').map((field) => ({
    numberKey: getHorseNumberFieldName(field.key),
    expiresKey: getHorseExpirationFieldName(field.key),
    imageKey: getHorseImageFieldName(field.key),
    label: field.label,
    icon: field.icon,
  })),
  Western: getDisciplineFields('Western').map((field) => ({
    numberKey: getHorseNumberFieldName(field.key),
    expiresKey: getHorseExpirationFieldName(field.key),
    imageKey: getHorseImageFieldName(field.key),
    label: field.label,
    icon: field.icon,
  })),
  Rodeo: getDisciplineFields('Rodeo').map((field) => ({
    numberKey: getHorseNumberFieldName(field.key),
    expiresKey: getHorseExpirationFieldName(field.key),
    imageKey: getHorseImageFieldName(field.key),
    label: field.label,
    icon: field.icon,
  })),
  College: getDisciplineFields('College').map((field) => ({
    numberKey: getHorseNumberFieldName(field.key),
    expiresKey: getHorseExpirationFieldName(field.key),
    imageKey: getHorseImageFieldName(field.key),
    label: field.label,
    icon: field.icon,
  })),
  Other: getDisciplineFields('Other').map((field) => ({
    numberKey: getHorseNumberFieldName(field.key),
    expiresKey: getHorseExpirationFieldName(field.key),
    imageKey: getHorseImageFieldName(field.key),
    label: field.label,
    icon: field.icon,
  })),
}
